import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./i18n";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { ConfigProvider } from "antd";
import cookie from "js-cookie";
import moment from "moment";
import "moment/locale/zh-cn";
import "moment/locale/zh-tw";
import "moment/locale/en-gb";
import "moment/locale/pt";
import "moment/locale/vi";
import "moment/locale/fr";
import "moment/locale/tr";
import "moment/locale/ru";
import "moment/locale/uk";
import "moment/locale/it";
import "moment/locale/es";
import "moment/locale/id";
import zh_cn from "antd/lib/locale/zh_CN";
import en_us from "antd/lib/locale/en_US";
import pt_pt from "antd/lib/locale/pt_PT";
import fr_fr from "antd/lib/locale/fr_FR";
import vi_vi from "antd/lib/locale/vi_VN";
import tr_tr from "antd/lib/locale/tr_TR";
import ru_ru from "antd/lib/locale/ru_RU";
import uk_ua from "antd/lib/locale/uk_UA";
import zh_tc from "antd/lib/locale/zh_TW";
import it_it from "antd/lib/locale/it_IT";
import es_es from "antd/lib/locale/es_ES";
import id_id from "antd/lib/locale/id_ID";
import ur_pk from "antd/lib/locale/ur_PK";
import { Locale } from "antd/lib/locale-provider";
import { getLang } from "@/util/config";
import { parse } from "querystring";
const langMap: { [key: string]: Locale } = {
  "en-us": en_us,
  "zh-cn": zh_cn,
  "pt-pt": pt_pt,
  "vi-vi": vi_vi,
  "fr-fr": fr_fr,
  "tr-tr": tr_tr,
  "ru-ru": ru_ru,
  "uk-ua": uk_ua,
  "zh-tc": zh_tc,
  "it-it": it_it,
  "es-es": es_es,
  "es-la": es_es,
  "id-id": id_id,
  "ur-pk": ur_pk,
};
const Lang = getLang();

// 设置 moment.js 的语言
const momentLangMap: { [key: string]: string } = {
  "en-us": "en-gb",
  "zh-cn": "zh-cn",
  "zh-tc": "zh-tw",
  "pt-pt": "pt",
  "vi-vi": "vi",
  "fr-fr": "fr",
  "tr-tr": "tr",
  "ru-ru": "ru",
  "uk-ua": "uk",
  "it-it": "it",
  "es-es": "es",
  "es-la": "es",
  "id-id": "id",
  "ur-pk": "ur",
};

// 设置 moment.js 的语言
moment.locale(momentLangMap[Lang] || "en-gb");

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const param: any = parse(window.location.search.slice(1));
// if (param.invite_code) {
//     cookie.set("invite_code", param.invite_code, {
//         expires: new Date(+new Date() + 1000 * 60 * 30),
//       });
//     sessionStorage.setItem("invite_code", param.invite_code);
// }

if (param.crm_token) {
//   cookie.set("crm_token", param.crm_token, {
//     expires: new Date(+new Date() + 1000 * 60 * 30),
//   });
//   sessionStorage.setItem("crm_token", param.crm_token);

  cookie.set("crm_token"+param?.invite_code, encodeURIComponent(param.crm_token), {
    expires: new Date(+new Date() + 1000 * 60 * 30),
  });
  sessionStorage.setItem("crm_token"+param?.invite_code, encodeURIComponent(param.crm_token));

  const params = Object.keys(param);
  let new_param = {}
  params.forEach(el => {
      if (el!== 'crm_token') {
        new_param[el] = param[el]
      }
  });
  let baseUrl = window.location.origin + window.location.pathname + "?";
  let url = baseUrl + JSON.stringify(new_param).replace(/[\"\{\}]/g,"").replace(/\:/g,"=").replace(/\,/g,"&");
  window.location.replace(url)
}
root.render(
//   <React.StrictMode>
    <ConfigProvider locale={langMap[Lang]}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ConfigProvider>
//   </React.StrictMode>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
